import ReactDOM from 'react-dom';
import React from 'react';
import $ from 'jquery';
import { handleOutriggersClick } from './ecoshadeScript.js';

export function getAssetsUrl(path) {
  return 'https://cdn.threehub.com/clients/masa/assets/' + path.join('/');
}

export function initConfigurator(api, id, options = {}) {
  const { elOrElId, configuration, form } = options;
  let el =
    typeof elOrElId === 'string' ? document.getElementById(elOrElId) : elOrElId;
  if (!el) el = document.getElementById('config-init-div');
  return api.configuration.initConfigurator({
    id,
    el,
    form: form || 'Default',
    configuration,
  });
}

let outriggersValue = '6T4AF';
export function setOutriggersValue(value) {
  outriggersValue = value;
}

export default {
  Extrudeck: function() {
    function EmbedElement() {
      return (
        <div
          id="obscurityScreen"
          style={{
            padding: '0.5em 0 0 0',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ width: '49%' }}>
            <img
              src={getAssetsUrl(['image', 'obscurity.png'])}
              style={{ width: '100%' }}
              alt="obscurity"
            />
          </div>
          <div
            style={{ width: '49%', alignItems: 'flex-end', display: 'flex' }}
          >
            <span>* Creates a smooth aesthetic when viewed from above.</span>
          </div>
        </div>
      );
    }

    let interval = setInterval(() => {
      const OSDiv = document.getElementsByClassName('ui toggle checkbox');
      const obscurityScreenMounted = document.getElementById('obscurityScreen')
        ? true
        : false;

      if (OSDiv && OSDiv[0] && !obscurityScreenMounted) {
        const rootEl = document.createElement('div');
        OSDiv[0].parentElement.appendChild(rootEl);
        ReactDOM.render(<EmbedElement />, rootEl);
        clearInterval(interval);
      }
    }, 200);
  },
  Ecoshade: function(api, attrName = null, value = null) {
    function EmbedElement({ flag, value }) {
      let temp = checkValue(api, value);

      if (flag === 'Open') {
        return (
          <div
            style={{
              padding: '0.5em 0 0 0',
              justifyContent: 'space-between',
            }}
          >
            <label>Outriggers & Infills- Open Frame</label>
            <br />
            <label>6"</label>
            <div
              style={{
                width: '320px',
                textAlign: 'center',
                margin: '0.3em',
                verticalAlign: 'top',
                border:
                  temp && (!value || (value && value.indexOf('6T4AF') !== -1))
                    ? '1px solid black'
                    : '1px solid white',
              }}
              id="6T4AF"
              className="option"
              onClick={() => optionOnClik(api, '6T4AF', 'Open')}
            >
              <img
                src="https://cdn.threehub.com/resources/images/filters:format(png)/2afc60b75ecb47d5239dc1d91523cbc4?filename=6T4AF.1024x512.jpg"
                style={{
                  border: '1px solid white',
                  cursor: ' pointer',
                  width: '100%',
                  height: ' 90px',
                  padding: '1px',
                  background: 'white',
                  display: 'block',
                }}
                alt="obscurity"
              />
            </div>
            <div
              style={{
                width: '320px',
                textAlign: 'center',
                margin: '0.3em',
                verticalAlign: 'top',
                border:
                  temp && (value && value.indexOf('6T6ZB') !== -1)
                    ? '1px solid black'
                    : '1px solid white',
              }}
              id="6T6ZB"
              className="option"
              onClick={() => optionOnClik(api, '6T6ZB', 'Open')}
            >
              <img
                src="https://cdn.threehub.com/resources/images/filters:format(png)/2adcb6683515bc547e452d3457990499?filename=6T6ZB.1024x512.jpg"
                style={{
                  border: '1px solid white',
                  cursor: ' pointer',
                  width: '100%',
                  height: ' 90px',
                  padding: '1px',
                  background: 'white',
                  display: 'block',
                }}
                alt="obscurity"
              />
            </div>
            <label>8"</label>
            <div
              style={{
                width: '320px',
                textAlign: 'center',
                margin: '0.3em',
                verticalAlign: 'top',
                border:
                  temp && (value && value.indexOf('8T6ZB') !== -1)
                    ? '1px solid black'
                    : '1px solid white',
              }}
              id="8T6ZB"
              className="option"
              onClick={() => optionOnClik(api, '8T6ZB', 'Open')}
            >
              <img
                src="https://cdn.threehub.com/resources/images/filters:format(png)/e609c45df186da4535cf9f2e8c7ff2f3?filename=8T6ZB.1024x512.jpg"
                style={{
                  border: '1px solid white',
                  cursor: ' pointer',
                  width: '100%',
                  height: ' 90px',
                  padding: '1px',
                  background: 'white',
                  display: 'block',
                }}
                alt="obscurity"
              />
            </div>
            <div
              style={{
                width: '320px',
                textAlign: 'center',
                margin: '0.3em',
                verticalAlign: 'top',
                border:
                  temp && (value && value.indexOf('8T6AF') !== -1)
                    ? '1px solid black'
                    : '1px solid white',
              }}
              id="8T6AF"
              className="option"
              onClick={() => optionOnClik(api, '8T6AF', 'Open')}
            >
              <img
                src="https://cdn.threehub.com/resources/images/filters:format(png)/1d99074dbf8e9a753c2cd84b9c8c14c5?filename=8T6AF.1024x512.jpg"
                style={{
                  border: '1px solid white',
                  cursor: ' pointer',
                  width: '100%',
                  height: ' 90px',
                  padding: '1px',
                  background: 'white',
                  display: 'block',
                }}
                alt="obscurity"
              />
            </div>
          </div>
        );
      } else {
        return (
          <div
            style={{
              padding: '0.5em 0 0 0',
              justifyContent: 'space-between',
            }}
          >
            <label>Outriggers & Infills- Closed Frame</label>
            <br />
            <label>6"</label>
            <div
              style={{
                width: '320px',
                textAlign: 'center',
                margin: '0.3em',
                verticalAlign: 'top',
                border: '1px solid black',
                border:
                  temp && (value && value.indexOf('6R4AF') !== -1)
                    ? '1px solid black'
                    : '1px solid white',
              }}
              id="6R4AF"
              className="option"
              onClick={() => optionOnClik(api, '6R4AF', 'Closed')}
            >
              <img
                src="https://cdn.threehub.com/resources/images/filters:format(png)/0232e37dde0b792524db85adb6415564?filename=6R4AF.1024x512.jpg"
                style={{
                  border: '1px solid white',
                  cursor: ' pointer',
                  width: '100%',
                  height: ' 90px',
                  padding: '1px',
                  background: 'white',
                  display: 'block',
                }}
                alt="obscurity"
              />
            </div>
            <div
              style={{
                width: '320px',
                textAlign: 'center',
                margin: '0.3em',
                verticalAlign: 'top',
                border:
                  temp && (value && value.indexOf('6R6ZB') !== -1)
                    ? '1px solid black'
                    : '1px solid white',
              }}
              id="6R6ZB"
              className="option"
              onClick={() => optionOnClik(api, '6R6ZB', 'Closed')}
            >
              <img
                src="https://cdn.threehub.com/resources/images/filters:format(png)/db89e5d53618d74b667a543beaa54b42?filename=6R6ZB.1024x512.jpg"
                style={{
                  border: '1px solid white',
                  cursor: ' pointer',
                  width: '100%',
                  height: ' 90px',
                  padding: '1px',
                  background: 'white',
                  display: 'block',
                }}
                alt="obscurity"
              />
            </div>
            <label>8"</label>
            <div
              style={{
                width: '320px',
                textAlign: 'center',
                margin: '0.3em',
                verticalAlign: 'top',
                border:
                  temp && (value && value.indexOf('8R6AF') !== -1)
                    ? '1px solid black'
                    : '1px solid white',
              }}
              id="8R6AF"
              className="option"
              onClick={() => optionOnClik(api, '8R6AF', 'Closed')}
            >
              <img
                src="https://cdn.threehub.com/resources/images/filters:format(png)/4c93e46d01acfb95ce04cbb0d69b7442?filename=8R6AF.1024x512.jpg"
                style={{
                  border: '1px solid white',
                  cursor: ' pointer',
                  width: '100%',
                  height: ' 90px',
                  padding: '1px',
                  background: 'white',
                  display: 'block',
                }}
                alt="obscurity"
              />
            </div>
            <div
              style={{
                width: '320px',
                textAlign: 'center',
                margin: '0.3em',
                verticalAlign: 'top',
                border:
                  temp && (value && value.indexOf('8R6ZB') !== -1)
                    ? '1px solid black'
                    : '1px solid white',
              }}
              id="8R6ZB"
              className="option"
              onClick={() => optionOnClik(api, '8R6ZB', 'Closed')}
            >
              <img
                src="https://cdn.threehub.com/resources/images/filters:format(png)/e41797644a9007b94a21a644dc1d4cc9?filename=8R6ZB.1024x512.jpg"
                style={{
                  border: '1px solid white',
                  cursor: ' pointer',
                  width: '100%',
                  height: ' 90px',
                  padding: '1px',
                  background: 'white',
                  display: 'block',
                }}
                alt="obscurity"
              />
            </div>
          </div>
        );
      }
    }

    if (api) {
      const config = api.configuration.getConfiguration();

      const interval = setInterval(() => {
        if ($('label:contains("Outriggers & Infills- Open Frame")').length) {
          const tempDiv = $(
            'label:contains("Outriggers & Infills- Open Frame")'
          );
          const nextDiv = tempDiv.next();
          tempDiv.remove();
          nextDiv.remove();
        }
        if ($('label:contains("Frame Type")').length) {
          const type = config['Frame Type'];
          const flag = type.indexOf('Close') !== -1 ? 'Close' : 'Open';
          let root = document.getElementById('outriggers');
          if (!root) {
            root = document.createElement('div');
            root.setAttribute('id', 'outriggers');
            $('label:contains("Frame Type")').parent().append(root);
          }

          if (
            (attrName === 'Outriggers & Infills- Open Frame' ||
              attrName === 'Outriggers & Infills- Closed Frame') &&
            attrName.indexOf(flag) !== -1
          ) {
            ReactDOM.render(<EmbedElement value={value} flag={flag} />, root);
          }
          if (
            attrName &&
            value &&
            attrName === 'Frame Type' &&
            value === 'Open w/ Round Nosing'
          ) {
            // if it is first time select 'open w/ Round Nosing', init the configurator to shouw 6" Profile and Crowns
            api.scene.setAll(
              { name: 'CF*', plug: 'Properties', property: 'visible' },
              false
            );
            api.scene.setAll(
              { name: '8R*', plug: 'Properties', property: 'visible' },
              false
            );
            api.scene.setAll(
              { name: '8T*', plug: 'Properties', property: 'visible' },
              false
            );
            api.scene.setAll(
              { name: '6R*', plug: 'Properties', property: 'visible' },
              false
            );
            api.scene.setAll(
              { name: '6T*', plug: 'Properties', property: 'visible' },
              false
            );
            api.scene.set(
              { name: '6T4AF F', plug: 'Properties', property: 'visible' },
              true
            );
            // $(`.option`).css({
            //   border: 'none',
            // });
            // $(`6T4AF`).css({
            //   border: '1px solid black',
            // });
          }

          if (attrName === 'Extended Infills') {
            if (outriggersValue && outriggersValue.charAt(1) === 'T') {
              const option = value === true ? ' E' : ' F';
              api.configuration.setConfiguration({
                'Outriggers & Infills- Open Frame': outriggersValue + option,
              });
            }
          }

          // if (attrName && attrName !== 'Frame Type' && outriggersValue) {
          //   $(`.option`).css({
          //     border: 'none',
          //   });
          //   $(`#${outriggersValue}`).css({
          //     border: '1px solid black',
          //   });
          // }

          clearInterval(interval);
        }
      }, 300);

      if (
        attrName &&
        value &&
        attrName === 'Frame Type' &&
        config['Mounting'] === 'Hanger Rod'
      ) {
        api.scene.setAll(
          {
            name: `HR*`,
            plug: 'Properties',
            property: 'visible',
          },
          false
        );
        api.scene.set(
          {
            name: `HR6`,
            plug: 'Properties',
            property: 'visible',
          },
          true
        );
      }

      if (
        attrName &&
        attrName === 'Mounting' &&
        value === 'Hanger Rod' &&
        outriggersValue
      ) {
        api.scene.setAll(
          {
            name: `HR*`,
            plug: 'Properties',
            property: 'visible',
          },
          false
        );
        api.scene.set(
          {
            name: `HR${outriggersValue.charAt(0)}`,
            plug: 'Properties',
            property: 'visible',
          },
          true
        );
      }
    }
  },
};

function optionOnClik(api, name, type) {
  if (api) {
    //change size of Outrigger frame reset Profiles and Crowns

    outriggersValue = name.trim();

    let openSufix = '';
    if (
      api.configuration.getConfiguration()['Extended Infills'] !== 'undefined'
    ) {
      if (outriggersValue && outriggersValue.charAt(1) === 'T') {
        openSufix =
          api.configuration.getConfiguration()['Extended Infills'] === true
            ? ' E'
            : ' F';
      }
    }

    if (type === 'Closed') {
      api.configuration.setConfiguration({
        'Outriggers & Infills- Closed Frame': name,
      });
    } else {
      api.configuration.setConfiguration({
        'Outriggers & Infills- Open Frame': outriggersValue + openSufix,
      });
    }

    // handleOutriggersClick(api, name, type);
  }
}

function checkValue(api, value) {
  const arr = api.configuration
    .getAttribute('Outriggers & Infills- Open Frame')
    .values.concat(
      api.configuration.getAttribute('Outriggers & Infills- Closed Frame')
        .values
    );
  if (value) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].indexOf(value.trim()) !== -1) {
        return true;
      }
    }
    return false;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/modules/config.js